import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Skeleton, Table, Row, Col, Button, Tag, Popconfirm } from "antd";
import { EyeOutlined, UndoOutlined } from "@ant-design/icons";
import { getClosingReports, reopenAccountingPeriod } from "../../../actions/accountingClosingAction";
import CreateClosing from "./CreateClosing";
import ReportDetails from "./ReportDetails";

const List = ({ getClosingReports, reopenAccountingPeriod, Auth, reload, setreload }) => {
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(true);
  const [selectedReport, setSelectedReport] = useState(null);
  const [reportModalVisible, setReportModalVisible] = useState(false);

  useEffect(() => {
    if (loading || reload) {
      getClosingReports().then((result) => {
        setdata(result);
        setloading(false);
        setreload(false);
      });
    }
  }, [reload, getClosingReports, setreload, loading]);

  const viewReport = (record) => {
    setSelectedReport(record);
    setReportModalVisible(true);
  };

  const handleReopen = (record) => {
    const periodId = record.period?.id || record.period;
    reopenAccountingPeriod(periodId).then((res) => {
      if (res) {
        setreload(true);
      }
    });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Start Date",
      key: "start_date",
      render: (text, record) => record.period_start_date || (record.period && record.period.start_date) || "N/A"
    },
    {
      title: "End Date",
      key: "end_date",
      render: (text, record) => record.period_end_date || (record.period && record.period.end_date) || "N/A"
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => viewReport(record)}
            style={{ marginRight: 8 }}
          >
            View Details
          </Button>
          {Auth.superuser && (
            <Popconfirm
              title="Are you sure you want to reopen this period? This will delete the closing report and closing entries."
              onConfirm={() => handleReopen(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button type="default" danger icon={<UndoOutlined />}>
                Reopen
              </Button>
            </Popconfirm>
          )}
        </>
      ),
    },
  ];

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <>
      <Row style={{ marginBottom: "20px" }}>
        <Col span={24}>
          <CreateClosing setreload={setreload} />
        </Col>
      </Row>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        bordered
      />

      {selectedReport && (
        <ReportDetails
          visible={reportModalVisible}
          onClose={() => setReportModalVisible(false)}
          report={selectedReport}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  Auth: state.auth,
});

export default connect(mapStateToProps, { getClosingReports, reopenAccountingPeriod })(List);
